import {
  infeasibilityReasonMessages,
  ServiceTask,
  ServiceTaskToggleablePlannedState,
  ServiceTaskType,
} from "@opstel/query/models/planTrainUnitDetails/serviceTask";
import { JSX } from "react";
import { Tooltip } from "@shared/EDS/components/Tooltip";

export interface TogglePlannedStateParameters {
  ptuGuid: string;
  serviceTaskType: ServiceTaskType;
  newPlannedState: ServiceTaskToggleablePlannedState;
}

export type TogglePlannedStateFn = (params: TogglePlannedStateParameters) => void;

interface ServiceTaskCellProps {
  readonly serviceTask: ServiceTask;
  readonly ptuGuid: string;
  readonly toggleServiceTask: TogglePlannedStateFn;
}

export function ServiceTaskCell({
  serviceTask,
  ptuGuid,
  toggleServiceTask,
}: ServiceTaskCellProps): JSX.Element {
  if (!serviceTask.isFeasible) {
    return (
      <Tooltip>
        <span>Niet mogelijk</span>
        <span>
          {serviceTask.infeasibilityReasons
            .map((reason) => infeasibilityReasonMessages[reason] ?? "Onbekende reden")
            .join(", ")}
        </span>
      </Tooltip>
    );
  }

  if (serviceTask.isPlanned === "YES_FIXED") {
    return (
      <tractie-icon
        name="check"
        stroke-width="thick"
        color="--tractie-color-content-success"
        title="Service vereist voor claim"
      />
    );
  }

  const isChecked = serviceTask.isPlanned === "YES";
  const handleCheckboxChange = () => {
    toggleServiceTask({
      ptuGuid,
      serviceTaskType: serviceTask.type,
      newPlannedState: serviceTask.isPlanned === "YES" ? "NO" : "YES",
    });
  };
  return (
    <tractie-toggle
      data-testid={`service-task-toggle-${ptuGuid}-${serviceTask.type}`}
      className="relative top-[6px]"
      checked={isChecked}
      onClick={handleCheckboxChange}
    />
  );
}
